import { ReactComponent as ListViewSVG } from "./svg/list.svg";
import { ReactComponent as ListViewDarkSVG } from "./svg/list_dark.svg";
import { ReactComponent as ListViewDisabledSVG } from "./svg/list_disabled.svg";
import "./IconListView.scss";

type IconListViewProps = {
  variant?: "active" | "inactive" | "disabled";
};

export const IconListView = ({ variant = "active" }: IconListViewProps) => {
  return (
    <span className="icon-list-view">
      {variant === "active" && <ListViewSVG />}
      {variant === "inactive" && <ListViewDarkSVG />}
      {variant === "disabled" && <ListViewDisabledSVG />}
    </span>
  );
};
